<script>
  import appConfig from "@/app.config";

  export default {
    page: {
      title: "Home",
      meta: [{ name: "description", content: appConfig.description }]
    },
  }
</script>
<template>
  <div>
    <div class="home-btn d-none d-sm-block">
      <router-link tag="a" to="/" class="text-dark">
        <i class="fas fa-home h2"></i>
      </router-link>
    </div>
    <section class="my-5 pt-5">
      <div class="container">
        <div class="home-wrapper text-center">

          <div class="justify-content-center text-dark">
                <span class="logo-lg font-weight-bold font-size-15 calibri bg-dark p-2 text-white" style="border-radius: 31px">
                  <img src="@/assets/images/logo-light.svg" alt height="19" />
                  पारसधाम
                </span>
          </div>

          <h3 class="mt-5">Welcome to Parasdham</h3>
          <p>Please select one from the following to proceed.</p>

          <div class="row">
            <div class="col-md-4 offset-md-1">
              <div class="card mt-4 maintenance-box">
                <div class="card-body">
                  <i class="bx bx-user mb-4 h1 text-primary"></i>
                  <h5 class="font-size-15 text-uppercase">New Member?</h5>
                  <p class="text-muted mb-0">
                    If you've never registered with us, Please click here to enroll yourself.
                  </p>
                  <router-link :to="{name: 'Visitors Entry'}" class="btn btn-primary mt-4 text-uppercase">
                    <i class="bx bxs-up-arrow mr-1"></i>
                    Signup
                  </router-link>
                </div>
              </div>
            </div>
            <div class="col-md-4 offset-md-1">
              <div class="card mt-4 maintenance-box">
                <div class="card-body">
                  <i class="bx bxs-user mb-4 h1 text-primary"></i>
                  <h5 class="font-size-15 text-uppercase">Already a member?</h5>
                  <p class="text-muted mb-0">
                    Please click here to login & access your account with us.
                  </p>
                  <router-link :to="{name: 'Member Login'}" class="btn btn-primary mt-4 text-uppercase">
                    <i class="bx bxs-right-arrow mr-1"></i>
                    Login
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
